import { GuruRecord } from '../types';

/**
 * Get the current officer/petugas name.
 * Priority: sessionStorage 'currentUser' → guruRecords email match → authUser displayName → fallback.
 */
export const getOfficerName = (
    guruRecords: GuruRecord[],
    authUser: { email?: string; displayName?: string } | null
): string => {
    const currentUser = sessionStorage.getItem('currentUser');
    if (currentUser) return currentUser;
    if (authUser?.email) {
        const guru = guruRecords.find(g => g.email === authUser.email);
        if (guru?.nama) return guru.nama;
    }
    return authUser?.displayName || 'Petugas Presensi';
};
